/**
 * Styled Components - Created by david on 26/02/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  background-color: #fff;
  width: 400px;
  height: 100vh;
  overflow: auto;
  z-index: 1;
  box-shadow: 0 -2px 0px rgba(0, 0, 0, 0.12), 0 -2px 6px rgba(0, 0, 0, 0.24);
`

export const Text = styled.div`
  color: #fff;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignerTool/DesignCenterCustomize/Tabs/styledComponents.tsx